
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 17.46c.396-.004 1.042-.02 1.34 0 .326.023.285.093.285.327 0 .878-.728 1.59-1.625 1.59s-1.625-.712-1.625-1.59c0-.223-.023-.303.3-.327.304-.022.94.004 1.325 0zM12 3.5c.69 0 1.25.448 1.25 1 0 .163-.049.423-.135.707 2.16.497 3.423 2.393 3.425 4.597l-.144 3.55c.972.333 2.351 1.223 2.354 2.222v.532c0 .436-.811.788-1.26.788H6.51c-.449 0-1.26-.352-1.26-.788v-.532c.003-1 1.365-1.889 2.336-2.222l-.132-3.55c.002-2.204 1.27-4.1 3.431-4.598-.086-.283-.135-.543-.135-.706 0-.552.56-1 1.25-1z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    